<template>
  <article class="">
    <cabeceraEN></cabeceraEN>
    <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>ETHICS LINE</h2>
    </section>
     <section class="descripcion">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <p>MEGA S.A.&#39;s Ethics Line is a tool designed to report Code of Ethics violations. This line is available 24/7 and is managed by a third-party firm, BDO, to guarantee confidentiality, anonymity, transparency.</p>        
            <img src="./linea-etica.jpg" alt="Banner de las plantas de Mega Cia." class="img-fluid">
          </div>
        </div>
      </div>
    </section>
    <section class="secundario">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <h4>Whistleblower Channels</h4>
            <ul>
              <li>Telephone: 0800-34-LINEA (54632)</li>
              <li>Webpage: <a href="http://www.bdolineaetica.com/ciamega" target="_blank">www.bdolineaetica.com/ciamega</a></li>
              <li>Email: <a href="mailto:ciamega@bdolineaetica.com">ciamega@bdolineaetica.com</a></li>
              <li>Mailing Address: Rondeau 2664 PB, C1262ABH CABA</li>
              <li>Personal Interviews: Maipú 942 PB, C1006ACN CABA</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="descargas">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8"> 
            <a href="static/pdf/manual-del-anuciante-mega.pdf" target="_blank"><img src="./icon-pdf.jpg" alt=""><span>DOWNLOAD MANUAL</span></a>
            <a href="static/pdf/Mega_ManualDeEtica_Mayo2021 (1).pdf" target="_blank"><img src="./icon-pdf.jpg" alt=""><span>DOWNLOAD CODE OF ETHICS</span></a>
          </div>
        </div>
      </div>
    </section>   
    <pieEN></pieEN>
  </article>
</template>

<script>
export default {
  name: 'lineaEticaEN',
  components: {
    CabeceraEN,
    PieEN
  }
}
import PieEN from '@/components/PieEN'
import CabeceraEN from '@/components/CabeceraEN'
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 50%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 28px
.descripcion 
  margin: 0
  padding: 0
  p 
    margin: 40px 0
.secundario
  margin: 0
  padding: 0
  h4 
    margin: 40px 0 30px
    font-size: 20px
    font-weight: 500
  ul 
    padding-left: 20px
    margin: 0
    li 
      list-style: circle
      a
        color: #004d9e
.descargas
  padding: 40px 0
  a
    padding-right: 30px
    display: inline-block
    vertical-align: top
    color: #004d9e
    font-weight: 500
    font-size: 14px
    @media(max-width: 550px)
      display: block
      padding: 0
    img,
    span
      display: inline-block
      vertical-align: middle
    img 
      padding-right: 10px

</style>



// WEBPACK FOOTER //
// src/components/linea-etica-en/lineaEtica-en.vue